webpackJsonp([34],{

/***/ 144:
/***/ (function(module, exports) {

module.exports = {"URL":"https://village2.extensionsoft.biz/api/"}

/***/ }),

/***/ 148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_config_json__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__static_config_json__);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
var URL = __WEBPACK_IMPORTED_MODULE_3__static_config_json___default.a.URL;
// const URL = '/api/'
/* harmony default export */ __webpack_exports__["a"] = ({
  getConfig: function getConfig(success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.get(URL + 'config').then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  UpdateConfig: function UpdateConfig(obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'config', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getMenus: function getMenus(header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.get(URL + 'menu', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  regisLine: function regisLine(obj, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.put(URL + 'line', obj).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getTokenLine: function getTokenLine(obj, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'line', obj).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getHomeAll: function getHomeAll(success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.get(URL + 'home/all').then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  UploadFile: function UploadFile(obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'upload', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getZoneAll: function getZoneAll(success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.get(URL + 'homezone/all').then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 150:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_css_index_css__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_css_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_css_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Vuex_store__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_mixin__ = __webpack_require__(181);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_4__Vuex_store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ 152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(7);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae4b0548_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(173);
var normalizeComponent = __webpack_require__(143)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae4b0548_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 155:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),_c('loading',{attrs:{"active":_vm.$store.state.isLoading,"can-cancel":false,"is-full-page":true},on:{"update:active":function($event){return _vm.$set(_vm.$store.state, "isLoading", $event)}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(175);


var Full = function Full() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 188));
};
var Login = function Login() {
  return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 189));
};
var page404 = function page404() {
  return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 190));
};

var Dashboard = function Dashboard() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 191));
};
var Users = function Users() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 192));
};
var Village = function Village() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 193));
};
var Zone = function Zone() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 194));
};
var Incomehome = function Incomehome() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 195));
};
var FormIncome = function FormIncome() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 196));
};
var FormUser = function FormUser() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 198));
};
var Invoice = function Invoice() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 199));
};
var InvoiceDetail = function InvoiceDetail() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 200));
};
var invoicePublic = function invoicePublic() {
  return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 201));
};
var Receipt = function Receipt() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 202));
};
var RegisLine = function RegisLine() {
  return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 203));
};
var Linenoti = function Linenoti() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 204));
};
var Expenditure = function Expenditure() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 205));
};
var ManageExpen = function ManageExpen() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 206));
};
var ExpenDetail = function ExpenDetail() {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 207));
};
var Setting = function Setting() {
  return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 208));
};
var Advertise = function Advertise() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 209));
};
var Outstanding = function Outstanding() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 210));
};
var Reporthome = function Reporthome() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 211));
};
var Reportincome = function Reportincome() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 212));
};
var Reportexpend = function Reportexpend() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 213));
};
var Reportcompare = function Reportcompare() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 214));
};
var Reportoverdue = function Reportoverdue() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 215));
};
var Reportreceivedetail = function Reportreceivedetail() {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 216));
};
var Reportincomeusermonth = function Reportincomeusermonth() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 217));
};
var Reportwater = function Reportwater() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 218));
};
var Reportcancelreceive = function Reportcancelreceive() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 219));
};
var Process = function Process() {
  return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 220));
};
var InvoiceCreateByHome = function InvoiceCreateByHome() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 221));
};

var originalPush = __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */].prototype.push;
__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */].prototype.push = function push(location) {
  return originalPush.call(this, location).catch(function (err) {
    return err;
  });
};
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
var titlename = ' | ระบบจัดการข้อมูลหมู่บ้าน';

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  base: '/',
  routes: [{
    path: '/',
    name: 'full',
    component: Full,
    children: [{
      path: '/',
      name: 'main',
      component: Dashboard,
      meta: { title: 'หน้าแรก', group_id: 8 }
    }, {
      path: '/users',
      name: 'users',
      component: Users,
      meta: { title: 'จัดการข้อมูลผู้ใช้งาน', group_id: 1 }
    }, {
      path: '/villages',
      name: 'villages',
      component: Village,
      meta: { title: 'จัดการข้อมูลทะเบียนบ้าน', group_id: 2 }
    }, {
      path: '/zone',
      name: 'zone',
      component: Zone,
      meta: { title: 'จัดการข้อมูลโซนที่อยู่', group_id: 2 }
    }, {
      path: '/incomehome',
      name: 'incomehome',
      component: Incomehome,
      meta: { title: 'บันทึกค่าใช้น้ำรายเดือน', group_id: 6 }
    }, {
      path: '/formincome/:id',
      name: 'formincome',
      component: FormIncome,
      meta: { title: 'บันทึกค่าใช้น้ำรายเดือน', group_id: 6 }
    }, {
      path: '/formuser',
      name: 'FormUser',
      component: FormUser,
      meta: { title: 'แก้ไขข้อมูลผู้ใช้งาน', group_id: 99 }
    }, {
      path: '/invoice',
      name: 'Invoice',
      component: Invoice,
      meta: { title: 'ข้อมูลใบแจ้งหนี้รายเดือน', group_id: 3 }
    }, {
      path: '/invoice_create_by_home',
      name: 'InvoiceCreateByHome',
      component: InvoiceCreateByHome,
      meta: { title: 'สร้างใบแจ้งหนี้ตามทะเบียนบ้าน', group_id: 3 }
    }, {
      path: '/invoice/:key',
      name: 'InvoiceDetail',
      component: InvoiceDetail,
      meta: { title: 'ข้อมูลยละเอียดใบแจ้งหนี้รายเดือน', group_id: 3 }
    }, {
      path: '/receipt',
      name: 'Receipt',
      component: Receipt,
      meta: { title: 'ใบเสร็จรับเงิน', group_id: 3 }
    }, {
      path: '/expenditure',
      name: 'Expenditure',
      component: Expenditure,
      meta: { title: 'บันทึกข้อมูลรายจ่าย', group_id: 4 }
    }, {
      path: '/expenditure/:id',
      name: 'EditExpenditure',
      component: Expenditure,
      meta: { title: 'แก้ไขข้อมูลรายจ่าย', group_id: 4 }
    }, {
      path: '/manageexp',
      name: 'ManageExpen',
      component: ManageExpen,
      meta: { title: 'ข้อมูลรายจ่าย', group_id: 4 }
    }, {
      path: '/manageexp/:id',
      name: 'expenddetail',
      component: ExpenDetail,
      meta: { title: 'ข้อมูลรายจ่าย', group_id: 4 }
    }, {
      path: '/setting',
      name: 'setting',
      component: Setting,
      meta: { title: 'ตั้งค่าระบบ', group_id: 7 }
    }, {
      path: '/advertise',
      name: 'Advertise',
      component: Advertise,
      meta: { title: 'แจ้งข่าวประชาสัมพันธ์', group_id: 7 }
    }, {
      path: '/outstandingmonth',
      name: 'Outstanding',
      component: Outstanding,
      meta: { title: 'สรุปยอดคงค้างรายเดือน', group_id: 5 }
    }, {
      path: '/reporthome',
      name: 'Reporthome',
      component: Reporthome,
      meta: { title: 'รายงานข้อมูลทะเบียนบ้าน', group_id: 5 }
    }, {
      path: '/reportincomemonth',
      name: 'Reportincome',
      component: Reportincome,
      meta: { title: 'รายงานการรับชำระ', group_id: 5 }
    }, {
      path: '/reportexpenmonth',
      name: 'Reportexpend',
      component: Reportexpend,
      meta: { title: 'สรุปรายจ่ายประจำเดือน', group_id: 5 }
    }, {
      path: '/compareexpenmonth',
      name: 'Reportcompare',
      component: Reportcompare,
      meta: { title: 'สรุปรายรับรายจ่ายประจำเดือน', group_id: 5 }
    }, {
      path: '/reportoverdue',
      name: 'Reportoverdue',
      component: Reportoverdue,
      meta: { title: 'รายงานค้างชำระแยกตามจำนวนเดือนค้างชำระ', group_id: 5 }
    }, {
      path: '/reportreceivedetail',
      name: 'Reportreceivedetail',
      component: Reportreceivedetail,
      meta: { title: 'รายงานรายละเอียดการรับชำระประจำวัน', group_id: 5 }
    }, {
      path: '/reportincomeusermonth',
      name: 'Reportincomeusermonth',
      component: Reportincomeusermonth,
      meta: { title: 'รายงานรับชำระแยกตามกลุ่มการชำระ', group_id: 5 }
    }, {
      path: '/reportwater',
      name: 'Reportwater',
      component: Reportwater,
      meta: { title: 'รายงานค่าน้ำ', group_id: 5 }
    }, {
      path: '/reportcancelreceive',
      name: 'Reportcancelreceive',
      component: Reportcancelreceive,
      meta: { title: 'รายงานยกเลิกใบเสร็จ', group_id: 5 }
    }, {
      path: '/process',
      name: 'Process',
      component: Process,
      meta: { title: 'ประมวลผลระบบ', group_id: 7 }
    }]
  }, {
    path: '/invoice_public/:key',
    name: 'invoicePublic',
    component: invoicePublic,
    meta: { title: 'ข้อมูลยละเอียดใบแจ้งหนี้รายเดือน', group_id: 3 }
  }, {
    path: '/regisline',
    name: 'RegisLine',
    component: RegisLine,
    meta: { title: 'ลงทะเบียนรับข้อมูลข่าวสารของหมู่บ้าน' }
  }, {
    path: '/noti',
    name: 'noti',
    component: Linenoti,
    meta: { title: 'ลงทะเบียนรับข้อมูลข่าวสารของหมู่บ้าน' }
  }, {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { title: 'เข้าสู่ระบบ' }
  }, {
    path: '*',
    name: 'P404',
    component: page404,
    meta: { title: 'Error Page' }
  }]
});

var DEFAULT_TITLE = titlename;
router.afterEach(function (to, from) {
  document.title = to.meta.title + titlename || DEFAULT_TITLE + titlename;
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 16,
	"./af.js": 16,
	"./ar": 17,
	"./ar-dz": 18,
	"./ar-dz.js": 18,
	"./ar-kw": 19,
	"./ar-kw.js": 19,
	"./ar-ly": 20,
	"./ar-ly.js": 20,
	"./ar-ma": 21,
	"./ar-ma.js": 21,
	"./ar-sa": 22,
	"./ar-sa.js": 22,
	"./ar-tn": 23,
	"./ar-tn.js": 23,
	"./ar.js": 17,
	"./az": 24,
	"./az.js": 24,
	"./be": 25,
	"./be.js": 25,
	"./bg": 26,
	"./bg.js": 26,
	"./bm": 27,
	"./bm.js": 27,
	"./bn": 28,
	"./bn.js": 28,
	"./bo": 29,
	"./bo.js": 29,
	"./br": 30,
	"./br.js": 30,
	"./bs": 31,
	"./bs.js": 31,
	"./ca": 32,
	"./ca.js": 32,
	"./cs": 33,
	"./cs.js": 33,
	"./cv": 34,
	"./cv.js": 34,
	"./cy": 35,
	"./cy.js": 35,
	"./da": 36,
	"./da.js": 36,
	"./de": 37,
	"./de-at": 38,
	"./de-at.js": 38,
	"./de-ch": 39,
	"./de-ch.js": 39,
	"./de.js": 37,
	"./dv": 40,
	"./dv.js": 40,
	"./el": 41,
	"./el.js": 41,
	"./en-SG": 42,
	"./en-SG.js": 42,
	"./en-au": 43,
	"./en-au.js": 43,
	"./en-ca": 44,
	"./en-ca.js": 44,
	"./en-gb": 45,
	"./en-gb.js": 45,
	"./en-ie": 46,
	"./en-ie.js": 46,
	"./en-il": 47,
	"./en-il.js": 47,
	"./en-nz": 48,
	"./en-nz.js": 48,
	"./eo": 49,
	"./eo.js": 49,
	"./es": 50,
	"./es-do": 51,
	"./es-do.js": 51,
	"./es-us": 52,
	"./es-us.js": 52,
	"./es.js": 50,
	"./et": 53,
	"./et.js": 53,
	"./eu": 54,
	"./eu.js": 54,
	"./fa": 55,
	"./fa.js": 55,
	"./fi": 56,
	"./fi.js": 56,
	"./fo": 57,
	"./fo.js": 57,
	"./fr": 58,
	"./fr-ca": 59,
	"./fr-ca.js": 59,
	"./fr-ch": 60,
	"./fr-ch.js": 60,
	"./fr.js": 58,
	"./fy": 61,
	"./fy.js": 61,
	"./ga": 62,
	"./ga.js": 62,
	"./gd": 63,
	"./gd.js": 63,
	"./gl": 64,
	"./gl.js": 64,
	"./gom-latn": 65,
	"./gom-latn.js": 65,
	"./gu": 66,
	"./gu.js": 66,
	"./he": 67,
	"./he.js": 67,
	"./hi": 68,
	"./hi.js": 68,
	"./hr": 69,
	"./hr.js": 69,
	"./hu": 70,
	"./hu.js": 70,
	"./hy-am": 71,
	"./hy-am.js": 71,
	"./id": 72,
	"./id.js": 72,
	"./is": 73,
	"./is.js": 73,
	"./it": 74,
	"./it-ch": 75,
	"./it-ch.js": 75,
	"./it.js": 74,
	"./ja": 76,
	"./ja.js": 76,
	"./jv": 77,
	"./jv.js": 77,
	"./ka": 78,
	"./ka.js": 78,
	"./kk": 79,
	"./kk.js": 79,
	"./km": 80,
	"./km.js": 80,
	"./kn": 81,
	"./kn.js": 81,
	"./ko": 82,
	"./ko.js": 82,
	"./ku": 83,
	"./ku.js": 83,
	"./ky": 84,
	"./ky.js": 84,
	"./lb": 85,
	"./lb.js": 85,
	"./lo": 86,
	"./lo.js": 86,
	"./lt": 87,
	"./lt.js": 87,
	"./lv": 88,
	"./lv.js": 88,
	"./me": 89,
	"./me.js": 89,
	"./mi": 90,
	"./mi.js": 90,
	"./mk": 91,
	"./mk.js": 91,
	"./ml": 92,
	"./ml.js": 92,
	"./mn": 93,
	"./mn.js": 93,
	"./mr": 94,
	"./mr.js": 94,
	"./ms": 95,
	"./ms-my": 96,
	"./ms-my.js": 96,
	"./ms.js": 95,
	"./mt": 97,
	"./mt.js": 97,
	"./my": 98,
	"./my.js": 98,
	"./nb": 99,
	"./nb.js": 99,
	"./ne": 100,
	"./ne.js": 100,
	"./nl": 101,
	"./nl-be": 102,
	"./nl-be.js": 102,
	"./nl.js": 101,
	"./nn": 103,
	"./nn.js": 103,
	"./pa-in": 104,
	"./pa-in.js": 104,
	"./pl": 105,
	"./pl.js": 105,
	"./pt": 106,
	"./pt-br": 107,
	"./pt-br.js": 107,
	"./pt.js": 106,
	"./ro": 108,
	"./ro.js": 108,
	"./ru": 109,
	"./ru.js": 109,
	"./sd": 110,
	"./sd.js": 110,
	"./se": 111,
	"./se.js": 111,
	"./si": 112,
	"./si.js": 112,
	"./sk": 113,
	"./sk.js": 113,
	"./sl": 114,
	"./sl.js": 114,
	"./sq": 115,
	"./sq.js": 115,
	"./sr": 116,
	"./sr-cyrl": 117,
	"./sr-cyrl.js": 117,
	"./sr.js": 116,
	"./ss": 118,
	"./ss.js": 118,
	"./sv": 119,
	"./sv.js": 119,
	"./sw": 120,
	"./sw.js": 120,
	"./ta": 121,
	"./ta.js": 121,
	"./te": 122,
	"./te.js": 122,
	"./tet": 123,
	"./tet.js": 123,
	"./tg": 124,
	"./tg.js": 124,
	"./th": 125,
	"./th.js": 125,
	"./tl-ph": 126,
	"./tl-ph.js": 126,
	"./tlh": 127,
	"./tlh.js": 127,
	"./tr": 128,
	"./tr.js": 128,
	"./tzl": 129,
	"./tzl.js": 129,
	"./tzm": 130,
	"./tzm-latn": 131,
	"./tzm-latn.js": 131,
	"./tzm.js": 130,
	"./ug-cn": 132,
	"./ug-cn.js": 132,
	"./uk": 133,
	"./uk.js": 133,
	"./ur": 134,
	"./ur.js": 134,
	"./uz": 135,
	"./uz-latn": 136,
	"./uz-latn.js": 136,
	"./uz.js": 135,
	"./vi": 137,
	"./vi.js": 137,
	"./x-pseudo": 138,
	"./x-pseudo.js": 138,
	"./yo": 139,
	"./yo.js": 139,
	"./zh-cn": 140,
	"./zh-cn.js": 140,
	"./zh-hk": 141,
	"./zh-hk.js": 141,
	"./zh-tw": 142,
	"./zh-tw.js": 142
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 176;

/***/ }),

/***/ 177:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation__ = __webpack_require__(180);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  user: [],
  token: null,
  screenHeight: 0,
  screenWidth: 0,
  isLoading: false,
  config: {},
  btnbottom: false
};

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutation__,
  state: state
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["clearState"] = clearState;
function clearState(state) {
  state.user = [];
  sessionStorage.clear();
}

/***/ }),

/***/ 181:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_crip_vue_notice__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_crip_vue_notice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_crip_vue_notice__);


var numeral = __webpack_require__(183);
var moment = __webpack_require__(0);
var ThaiBaht = __webpack_require__(184);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_crip_vue_notice___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin({
  methods: {
    checkUser: function checkUser() {
      if (sessionStorage.user) {
        this.$store.state.token = sessionStorage.token;
        this.$store.state.user = JSON.parse(sessionStorage.user);
        if (sessionStorage.config) {
          this.$store.state.config = JSON.parse(sessionStorage.config);
        }
      } else {
        this.$router.push('/login');
      }
    },
    dateYearThai: function dateYearThai(date) {
      return moment(date).format('YYYY');
    },
    dateMonth: function dateMonth(date) {
      return moment(date).format('YYYY-MM');
    },
    alert_msg: function alert_msg(type, title, text) {
      this.$notice[type]({
        title: title,
        description: text
      });
    },
    dateFormat: function dateFormat(date) {
      return moment(date).format('L');
    },
    dateFormatDMY: function dateFormatDMY(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    dateTimeFormat: function dateTimeFormat(date) {
      return moment(date).format('DD/MM/YYYY HH:mm:ss');
    },
    dateFormatDMY2: function dateFormatDMY2(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    dateFormatMY: function dateFormatMY(date) {
      return moment(date).format('MM/YYYY');
    },
    monthFormat: function monthFormat(str) {
      switch (str) {
        case '01':
          return 'ม.ค';
        case '02':
          return 'ก.พ';
        case '03':
          return 'มี.ค';
        case '04':
          return 'เม.ย';
        case '05':
          return 'พ.ค';
        case '06':
          return 'มิ.ย';
        case '07':
          return 'ก.ค';
        case '08':
          return 'ส.ค';
        case '09':
          return 'ก.ย';
        case '10':
          return 'ต.ค';
        case '11':
          return 'พ.ย';
        default:
          return 'ธ.ค';
      }
    },
    monthYearFormat: function monthYearFormat(str) {
      var date = str.split('-');
      switch (date[1]) {
        case '01':
          return 'มกราคม ' + date[0];
        case '02':
          return 'กุมภาพันธ์ ' + date[0];
        case '03':
          return 'มีนาคม ' + date[0];
        case '04':
          return 'เมษายน ' + date[0];
        case '05':
          return 'พฤษภาคม ' + date[0];
        case '06':
          return 'มิถุนายน ' + date[0];
        case '07':
          return 'กรกฎาคม ' + date[0];
        case '08':
          return 'สิงหาคม ' + date[0];
        case '09':
          return 'กันยายน ' + date[0];
        case '10':
          return 'ตุลาคม ' + date[0];
        case '11':
          return 'พฤศจิกายน ' + date[0];
        default:
          return 'ธันวาคม ' + date[0];
      }
    },
    numberFormat: function numberFormat(str) {
      return numeral(str).format('0,0.00');
    },
    numberFormatold: function numberFormatold(str) {
      return numeral(str).format('0,0');
    },
    moneyText: function moneyText(str) {
      return ThaiBaht(str);
    },
    convert_vs: function convert_vs(val) {
      var data = [];
      var len = 3;
      if (val.length > 3) {
        len = val.length;
      }
      var vallen = val.length;
      for (var i = 0; i < len; i++) {
        var v = val.split('');
        if (len - i === vallen) {
          var ss = len - i;
          if (ss === vallen) {
            if (val.length === 1) {
              data.push(val);
            } else {
              if (len > val.length) {
                data.push(v[i - 1]);
              } else {
                data.push(v[i]);
              }
            }
          } else {
            data.push(v[i - 1]);
          }
          vallen--;
        } else {
          data.push('0');
        }
      }
      var versions = '';
      for (var l = 0; l < data.length; l++) {
        versions += data[l];
        if (l < data.length - 1) {
          versions += '.';
        }
      }
      return versions;
    },
    getParam: function getParam(param) {
      var url = new URL(window.location.href);
      var c = url.searchParams.get(param);
      return c;
    }
  }
});

/***/ }),

/***/ 7:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_service__ = __webpack_require__(148);

//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_1_vue_loading_overlay___default.a
  },
  created: function created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    handleResize: function handleResize() {
      this.$store.state.screenWidth = window.innerWidth;
      this.$store.state.screenHeight = window.innerHeight;
    },
    getConfig: function getConfig() {
      var _this = this;

      this.$store.state.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_3__services_service__["a" /* default */].getConfig(function (result) {
        if (result.response === true) {
          _this.$store.state.config = result.data;
          sessionStorage.config = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result.data);
        } else {
          _this.getConfig();
        }
        _this.$store.state.isLoading = false;
      }, function (error) {
        alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        _this.$store.state.isLoading = false;
      });
    }
  },
  mounted: function mounted() {
    this.getConfig();
  }
});

/***/ })

},[150]);


// WEBPACK FOOTER //
// static/js/app.6b2579160e2a51e8b8ca.js